module.exports = __webpack_public_path__ + "xml/carpardoo/browserconfig.xml";